import Phaser from 'phaser';
import { GAME_HEIGHT, GAME_WIDTH } from '../config';
import { getGameRuntime } from '../runtime';

export class VejleMapScene extends Phaser.Scene {
  constructor() {
    super('VejleMap');
  }

  create(): void {
    const runtime = getGameRuntime();
    this.cameras.main.fadeIn(320, 10, 22, 34);
    this.add
      .image(GAME_WIDTH / 2, GAME_HEIGHT / 2, 'map-background')
      .setDisplaySize(GAME_WIDTH, GAME_HEIGHT);

    // Alle markører tegnes i DOM-laget, så redigering og tastatur bruger samme position.
    runtime.events.emit('scene:map');
    runtime.events.emit('scene:hotspots', []);
    runtime.events.emit('audio:theme', { theme: 'map' });
  }
}
